import { ACTIONS } from '../../components/myeirconstant/myEirConstant';
import { getUserOTCInfo } from '../../mobilecomponents/redesign-5.2/help-and-support/troubleshooting-tile/troubleshooting.util';
import { createVirtualLink } from './createVirtualLink';

/**
 * @name handleAction - Handles actions based on action defined in strapi
 * @param {string} action - Action type to perform
 * @param {string} redirectUrl - Redirection URl provided in strapi for specfic action
 * @param  {Array} states -Handles states passed from parent
 */
export const handleAction = async (action, redirectUrl, ...states) => {
    const { SWEEPR_TROUBLESHOOT, GENERIC_REDIRECT, GENERIC_CALL_DIALER } = ACTIONS;
    const [graphql, setSweeprParams, toggleError] = states;

    switch (action) {
        case SWEEPR_TROUBLESHOOT:
            await getUserOTCInfo({ graphql, setSweeprParams, toggleError });
            break;
        case GENERIC_REDIRECT:
            createVirtualLink(redirectUrl);
            break;
        case GENERIC_CALL_DIALER:
            window.location.href = `tel:${redirectUrl}`;
            break;
        default:
            logger.log('error', 'Unhandled action', action);
            break;
    }
};
